import { Component } from '@angular/core';
import { NavParams, ViewController } from 'ionic-angular';

import { CadastroPerguntasService } from '../../../providers/cadastro-perguntas-service';

/*
  Generated class for the ModalCadastroPerguntas page.

  See http://ionicframework.com/docs/v2/components/#navigation for more info on
  Ionic pages and navigation.
*/
@Component({
  selector: 'page-modal-cadastro-perguntas',
  templateUrl: 'modal-cadastro-perguntas.html',
  providers: [
    CadastroPerguntasService
  ]
})
export class ModalCadastroPerguntasPage {
  objeto: any;
  titulo: any;
  isJurisdicionado: any;

  constructor(private viewCtrl: ViewController, public navParams: NavParams) {
    this.titulo = this.navParams.get('param1');
    this.objeto = this.navParams.get('param2');
  }
  dismiss() {
    this.viewCtrl.dismiss();
  }

  salvarEdicacao() {
    this.viewCtrl.dismiss(this.objeto);
  }

}



// WEBPACK FOOTER //
// ./src/pages/modais/modal-cadastro-perguntas/modal-cadastro-perguntas.ts